// src/components/layout/Footer.js
import React from 'react';

function Footer() {
    return (
        <footer className="main-footer">
            {/* To the right */}
            <div className="float-right d-none d-sm-inline">
                AdminLTE 3 React Template
            </div>
            {/* Default to the left */}
            <strong>Copyright © {new Date().getFullYear()} <a href="#">Your Company</a>.</strong> All rights reserved.
        </footer>
    );
}

export default Footer;